import type { AuthUser } from "./types";

export type AppView = "planner" | "planning-data" | "work" | "work-label" | "workpiece" | "projects" | "workers" | "settlement" | "field" | "tablet" | "rack-tablet" | "rack-status" | "rack-overview" | "ops" | "account" | "users" | "activity-history" | "legacy-work-records" | "aligo" | "printer" | "announcements";

const viewTabs: Partial<Record<AppView, string>> = {
  planner: "planner",
  "planning-data": "planner",
  work: "issuance",
  "work-label": "issuance",
  workpiece: "issuance",
  projects: "projects",
  workers: "studio-admin",
  settlement: "settlements",
  field: "field",
  ops: "operations",
  "rack-status": "operations",
  "rack-overview": "operations",
};

/**
 * The worker directory currently contains private details and editing controls,
 * so it is an editor surface rather than a read-only report. Keep this rule in
 * the route policy instead of letting the page render an empty editor shell.
 */
const writeOnlyViews = new Set<AppView>(["workers"]);

export function canAccessView(user: AuthUser, view: AppView) {
  if (user.role === "viewer") {
    if (view === "account") return true;
    return ["planner", "work", "projects", "ops"].includes(view) && user.tabs.includes(viewTabs[view]!);
  }
  if (view === "tablet" || view === "rack-tablet" || view === "account") return true;
  if (view === "users" || view === "activity-history" || view === "legacy-work-records" || view === "aligo" || view === "printer") return user.role === "admin";
  if (view === "rack-overview" && user.role === "admin") return true;
  if (view === "announcements") return user.role === "admin" || user.role === "editor";
  if (user.role === "worker") return view === "field";
  const tab = viewTabs[view];
  if (!tab || !user.tabs.includes(tab)) return false;
  return !writeOnlyViews.has(view) || user.writeTabs.includes(tab);
}
